module.exports = __webpack_public_path__ + "img/img-af234622.c180d5cd.png";